module.exports = __webpack_public_path__ + "img/contact.a3d5ec47.svg";